import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Content from '../../components/layout/Content';
import BookingReviewCMS from './BookingReviewCMS';
import CalendarSelectionCMS from './CalendarSelectionCMS';
import ConfirmationCMS from './ConfirmationCMS';
import EnterDetailsCMS from './EnterDetailsCMS';
import PathSelectionCMS from './PathSelectionCMS';
import ServiceSelectionCMS from './ServiceSelectionCMS';
import LoginCMS from './LoginCMS';
import StoreSelectionCMS from './StoreSelectionCMS';

const BookingFunnelCMS = () => {
    const navigate = useNavigate();

    return (
        <Content>
            <div className='container mx-auto py-10'>
                <div className='flex items-center gap-4 mb-6'>
                    <Button variant='ghost' size='icon' onClick={() => navigate('/cms')}>
                        <ArrowLeft className='h-4 w-4' />
                    </Button>
                    <div>
                        <h1 className='text-3xl font-bold'>Booking Funnel CMS</h1>
                        <p className='text-muted-foreground'>
                            Verwalten Sie Texte und Bilder für den Buchungs-Funnel.
                        </p>
                    </div>
                </div>

                <Tabs defaultValue='store-selection' className='w-full'>
                    <TabsList className='mb-6'>
                        <TabsTrigger value='store-selection'>1. Standort</TabsTrigger>
                        <TabsTrigger value='path-selection'>2. Pfad-Auswahl</TabsTrigger>
                        <TabsTrigger value='service-selection'>3. Leistungen</TabsTrigger>
                        <TabsTrigger value='calendar-selection'>4. Kalender</TabsTrigger>
                        <TabsTrigger value='enter-details'>5. Details</TabsTrigger>
                        <TabsTrigger value='booking-review'>6. Übersicht</TabsTrigger>
                        <TabsTrigger value='confirmation'>7. Bestätigung</TabsTrigger>
                        <TabsTrigger value='login'>8. Login</TabsTrigger>
                    </TabsList>

                    <TabsContent value='store-selection'>
                        <StoreSelectionCMS />
                    </TabsContent>

                    <TabsContent value='path-selection'>
                        <PathSelectionCMS />
                    </TabsContent>

                    <TabsContent value='service-selection'>
                        <ServiceSelectionCMS />
                    </TabsContent>

                    <TabsContent value='calendar-selection'>
                        <CalendarSelectionCMS />
                    </TabsContent>

                    <TabsContent value='enter-details'>
                        <EnterDetailsCMS />
                    </TabsContent>

                    <TabsContent value='booking-review'>
                        <BookingReviewCMS />
                    </TabsContent>

                    <TabsContent value='confirmation'>
                        <ConfirmationCMS />
                    </TabsContent>

                    <TabsContent value='login'>
                        <LoginCMS />
                    </TabsContent>
                </Tabs>
            </div>
        </Content>
    );
};

export default BookingFunnelCMS;
